var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { extend } from "lodash";
import SimpleMarkdown from "simple-markdown";
import theme from "@irati/ui/src/global/theme";
import Expander from "../Expander";
import { StyledExpanderIcon, HeaderLabel } from "./styled";
var paragraphStyles = {
    color: theme.colors.utility.contrast,
    fontSize: 16,
    letterSpacing: 0.3,
    marginBottom: theme.spacing.oneAndHalf
};
var anchorStyles = {
    color: theme.colors.primary1,
    fontFamily: theme.font.bold
};
var paragraphRule = extend({}, SimpleMarkdown.defaultRules.paragraph, {
    react: function (node, output, state) {
        return (React.createElement("p", { key: state.key, style: paragraphStyles }, output(node.content)));
    }
});
var anchorRule = extend({}, SimpleMarkdown.defaultRules.link, {
    react: function (node, output, state) {
        var props = {
            key: state.key,
            href: SimpleMarkdown.sanitizeUrl(node.target),
            title: node.title,
            target: "_blank",
            style: anchorStyles
        };
        return React.createElement("a", __assign({}, props), output(node.content));
    }
});
var strongRule = extend({}, SimpleMarkdown.defaultRules.strong, {
    react: function (node, output, state) {
        return (React.createElement("span", { key: state.key, style: __assign(__assign({}, paragraphStyles), { fontFamily: theme.font.bold }) }, output(node.content, state)));
    }
});
var expandRule = {
    order: SimpleMarkdown.defaultRules.codeBlock.order + 0.5,
    match: function (source) { return /^\|:(.+)\n([\s\S]+?):\|/.exec(source); },
    parse: function (capture, parse, state) {
        return {
            buttonText: capture[1],
            content: parse(capture[2] + "\n\n", state)
        };
    },
    react: function (node, output, state) {
        return (React.createElement("div", { key: state.key },
            React.createElement(Expander, { showText: node.buttonText, hideText: node.buttonText, Arrow: StyledExpanderIcon, HeaderLabel: HeaderLabel }, output(node.content, { inline: false }))));
    }
};
var rules = extend({}, SimpleMarkdown.defaultRules, {
    link: anchorRule,
    strong: strongRule,
    expand: expandRule,
    paragraph: paragraphRule
});
var parser = SimpleMarkdown.parserFor(rules);
var reactOutput = SimpleMarkdown.reactFor(SimpleMarkdown.ruleOutput(rules, "react"));
var Markdown = function (props) {
    // @notes: Many rules require content to end in \n\n to be interpreted as a block. (notes from simple-markdown)
    var blockSource = (props.source || "") + "\n\n";
    var parseTree = parser(blockSource, { inline: false });
    return React.createElement("div", { className: props.className }, reactOutput(parseTree));
};
export default Markdown;
